import { UseQueryResult } from "@tanstack/react-query";
import { OrganizationApiResponse } from "../../types/api.types";
import { queryKeys } from "../queryKeys";
import { useAppQuery, UseAppQueryOptions } from "../useAppQuery";

/**
 * Hook to fetch the current organization data
 * Replaces the Organization.get() static method pattern
 *
 * @example
 * const { data, isLoading, error } = useOrganization();
 * if (isLoading) return <Spinner />;
 * if (error) return <Error />;
 * return <OrgInfo organization={data?.organization} />;
 */
export function useOrganization(
  options?: Omit<UseAppQueryOptions<OrganizationApiResponse, Error>, "queryKey">
): UseQueryResult<OrganizationApiResponse, Error> {
  return useAppQuery<OrganizationApiResponse, Error>("/Organization", {
    ...options,
    queryKey: queryKeys.organization.current()
  });
}
